import { isBooleanTrue, isNotNullOrUndefined, isObjectNotEmpty, isStringEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { v4 as uuid } from 'uuid';
import moment from "moment-timezone";

class ChatMessage {
    id = uuid(); // id of the message
    encounterId = null; // id of the encounter this message belongs to
    message = null; // message content
    mediaRefId = null; // message media

    sentName = null; // sender display name
    sentBy = null; // userId of the sender
    sentAt = moment().utc().toDate();

    readAt = null;
    isRead = false;

    constructor(chatMessage) {
        if (isObjectNotEmpty(chatMessage)) {
            if (isStringNotEmpty(chatMessage.id)) { this.id = chatMessage.id; }
            if (isStringNotEmpty(chatMessage.encounterId)) { this.encounterId = chatMessage.encounterId; }
            if (isStringNotEmpty(chatMessage.message)) { this.message = chatMessage.message; }
            if (isStringNotEmpty(chatMessage.mediaRefId)) { this.mediaRefId = chatMessage.mediaRefId; }

            if (isStringNotEmpty(chatMessage.sentName)) { this.sentName = chatMessage.sentName; }
            if (isStringNotEmpty(chatMessage.sentBy)) { this.sentBy = chatMessage.sentBy; }
            if (isNotNullOrUndefined(chatMessage.sentAt)) { this.sentAt = chatMessage.sentAt; }

            if (isNotNullOrUndefined(chatMessage.readAt)) { this.readAt = chatMessage.readAt; }
            if (isBooleanTrue(chatMessage.isRead)) { this.isRead = true; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            encounterId: this.encounterId,
            message: this.message,
            mediaRefId: this.mediaRefId,

            sentName: this.sentName,
            sentBy: this.sentBy,
            sentAt: this.sentAt,

            readAt: this.readAt,
            isRead: this.isRead,
        };
    }

    isValid = () => {
        if (isStringEmpty(this.encounterId)) {
            throw new Error('Encounter ID is required.');
        }

        return true;
    }
};

export default ChatMessage;